import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { ExitReasonsEnum } from "@gtpl/shared-models/common-models";

@Entity('exit_action')
export class ExitAction{

    @PrimaryGeneratedColumn('increment', {name: 'exit_action_id'})
    exitActionId: number;

    @Column('int', {
        nullable: false,
        name: 'employee_id'
    })
    employeeId: number;

    @Column({
        nullable: false,
        name: 'exit_date'
    })
    exitDate: Date;

    @Column({
        type: 'enum',
        enum: ExitReasonsEnum,
        nullable: false,
        name: 'exit_reason',
        default: ExitReasonsEnum.LACK_OF_CAREER_GROWTH,
    })
    exitReason: ExitReasonsEnum;

    @Column('varchar',{
        nullable: true,
        length: 30,
        name: 'remarks'
    })
    remarks: string;

    @Column('int', {
        nullable: false,
        name: 'approved_by'
    })
    approvedBy: number;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;
    
    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}